import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 默认关闭
      dialogVisible: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        certTypeNum: null, // 资质资格类型
        listCode: null, // 编码
        listName: null, // 序列名称
        parentList: null, // 上级序列
      },
      // 查询表单
      formSearchList: [
        {
          type: "select",
          label: "资质资格类型：",
          value: "certTypeNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131554050002"
          }
        },
        {
          type: "input",
          label: "编码：",
          value: "listCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "序列名称：",
          value: "listName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "上级序列：",
          value: "parentList",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "资质资格类型",
          prop: "certTypeName",
        },
        {
          label: "编码",
          prop: "listCode",
        },
        {
          label: "序列名称",
          prop: "listName",
        },
        {
          label: "上级序列",
          prop: "parentList",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
    };
  },
  // 接收来自父组件的数据
  props: {

  },
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/corpQualificationList/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 资质类型
      if (i === "certTypeNum") {
        // 赋值
        this.form.certTypeNum = e;
      }
    },
    /**
     * 专业大类赋值
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_SetCorpQualificationList(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面专业大类
        this.$parent.form.tradeLargeClass = e.id;
        // 赋值父页面专业大类名称
        this.$parent.form.tradeLargeClassName = e.listName;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
};
